import React, { useState, useEffect } from "react"
import Select from "react-select"

const Paginator = ({ initialPage, id,filter,items, service,shouldGetData, setShouldGetData,pageOptions, setData, setPageOptions, filtersParams = {} }) => {
    const [pager, setPager] = useState(null)
    const [dataFiltered, setDataFiltered] = useState([])
    const [perPage, setPerPage] = useState({label: '10', value: 10})
    const [paramsData, setParamsData] = useState(null)

    const customizeRates = (rates) => {
        if (rates?.length === 0) {
            return
        }
        const DeveloperRates = []
        for (const developer in rates) {
            const developerRate = {
                ...rates[developer],
                name: rates[developer].name,
                developer_id: id,
                craterias: [],
                rate: 0,
                count: 0,
                id: rates[developer].id,
                status: rates[developer].status,
                areas: []
            }
            // let areas = []
            // rates[developer]?.map((item, index) => {
            //     areas?.push(...item.areas)
            //     developerRate?.areas?.push(...item.areas)
            // })
            
            rates[developer]?.ratings?.forEach((item, index) => {
                const crateria = {
                    id: item?.id,
                    rating_criteria: {
                        label: item?.name?.en,
                        value: parseFloat(item?.pivot?.rating_criteria_id)
                    },
                    rate: parseFloat(item?.pivot?.rate)
                }
                developerRate.rate = parseInt(developerRate.rate) + parseInt(item?.pivot?.rate)
                developerRate.count = parseFloat(developerRate.count) + 1
                developerRate.craterias.push(crateria)
            })
            
            const rate = (Number.isInteger(developerRate?.rate/developerRate?.count))?((developerRate?.rate/developerRate?.count)):((developerRate?.rate/developerRate?.count).toFixed(2))

            if (!!filter?.fromRate && !!filter?.toRate ) {
                if (rate >= parseFloat(filter.fromRate)
                    && rate <= parseFloat(filter.toRate)) {
                    DeveloperRates.push(developerRate)
                }
            } else if (!!filter?.fromRate) {
                if (rate >= parseFloat(filter.fromRate)) {
                    DeveloperRates.push(developerRate)
                }
            } else if (!!filter?.toRate) {
                if (rate <= parseFloat(filter.toRate)) {
                    DeveloperRates.push(developerRate)
                }
            } else {
                DeveloperRates.push(developerRate)
            }
        }
        // if (DeveloperRates?.length === 0) {
        //     setData([])
        //     // setDevelopersList([])
        // } else {
        //     setData([...])
        //     setDataResult([...DeveloperRates])
        //     // setDevelopersList([...DeveloperRates])
        // }
        
        return DeveloperRates
    }

    useEffect(() => {
       if(shouldGetData){   
        setPage(pager?.currentPage)
       }
    }, [shouldGetData])

    useEffect(() => {
        setPage(pager?.currentPage)
    }, [perPage])

    useEffect(() => {
         setParamsData(filtersParams)
    }, [filtersParams])

    useEffect(() => {
        if (!paramsData) {
             return
        } else {
             setPage(1)
        }
    }, [paramsData])

    const setPage = async (page) => {
         let pagerData = pager;
         if (page < 1 ) {
            return;
        }
     
        // get new pager object for specified page
        pagerData = getPager(items?.length, page);

        // get new page of items from items array
        // var pageOfItems = items.slice(pager.startIndex, pager.endIndex + 1);

        const params = {
            page: page,
            per_page: perPage?.value,
            ...paramsData
        }
        
         
        const { data: itemList } = await service?.getList(params); 

        setShouldGetData(false)
        
        let data = []
        let newPage 
        setData([]);
        if(!!filter?.fromRate || !!filter?.toRate){
            data = itemList?.source?.length > 0 ? customizeRates([...itemList?.source]) : []
            newPage=  data?.length 
            pagerData = getPager( newPage, page,newPage)
        }else{
            data = itemList?.source?.length > 0 ? customizeRates([...itemList?.paginated?.data]) : []
            newPage = itemList?.paginated?.meta?.total
            pagerData = getPager( newPage, page)
        }

        setData([...data])
        setDataFiltered([...data])

        setPageOptions({ ...pageOptions, totalSize: newPage });
        
        // pagerData = getPager(data.length >= 10 || itemList?.meta?.current_page > 1  ? itemList?.meta?.total : data.length, page);
        
        setPager(pagerData);
        
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        })
        // call change page function in parent component
    }

    
    const getPager = (totalItems, currentPage, pageSize) => {
        // default to first page
        currentPage = currentPage || 1;

        // default page size is 10
        pageSize = pageSize || perPage?.value;

        // calculate total pages
        var totalPages = Math.ceil(totalItems / pageSize);

        var startPage, endPage;
        if (totalPages <= 10) {
            // less than 10 total pages so show all
            startPage = 1;
            endPage = totalPages;
        } else {
            // more than 10 total pages so calculate start and end pages
            if (currentPage <= 6) {
                startPage = 1;
                endPage = 10;
            } else if (currentPage + 4 >= totalPages) {
                startPage = totalPages - 9;
                endPage = totalPages;
            } else {
                startPage = currentPage - 5;
                endPage = currentPage + 4;
            }
        }

        // calculate start and end item indexes
        var startIndex = (currentPage - 1) * pageSize;
        var endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);

        // create an array of pages to ng-repeat in the pager control
        var pages = [...Array((endPage + 1) - startPage).keys()].map(i => startPage + i);

        // return object with all pager properties required by the view
         return {
            totalItems: totalItems,
            currentPage: currentPage,
            pageSize: pageSize,
            totalPages: totalPages,
            startPage: startPage,
            endPage: endPage,
            startIndex: startIndex,
            endIndex: endIndex ,
            pages: pages
        };
    }
    // if (!pager ?.pages || pager.pages ?.length <= 1) {
    //     // don't display pager if there is only 1 page

    //     return null;
    // }

    return (<>
            <div style={{width: '6rem'}} className="pagination-div">
                <Select
                    options={[
                        {label: '10', value: 10},
                        {label: '20', value: 20},
                        {label: '50', value: 50},
                        {label: '100', value: 100},
                    ]}
                    className='w-100'
                    onChange={data => setPerPage(data)}
                    value={perPage}
                />
            </div>
            <ul className="pagination ">
                <li style={{ marginRight: "5px" }} className='page-item  rounded'>
                    <a className='page-link border-0   rounded text-dark '
                        style={{ fontSize: "24px", opacity: pager ?.currentPage === 1 ? .3 : 1 }}
                        onClick={() => {
                            if (pager ?.currentPage === 1) {
                                return
                            } else {
                                setPage(pager ?.currentPage - 1)
                                return
                            }
                        }}>&lt;</a>
                </li>
                {pager?.totalPages > 10 && pager?.currentPage >= 7  &&
                    <>
                    <li className={pager ?.currentPage === pager?.totalPages ?
                            ' page-link border-0 rounded  text-light  ' :
                            'page-link border-0  rounded text-dark  '}
                    >
                        
                        <a className={pager ?.currentPage === pager.startPage ?
                            ' page-link border-0 rounded  text-light  ' :
                            'page-link border-0  rounded text-dark  '}
                            style={{ userSelect: "none", background: pager ?.currentPage === pager.startPage ? "#25375c" : "#ffffff", fontSize: "12px", }}
                            onClick={() => {
                                if (pager.startPage == pager ?.currentPage) {
                                    return
                                } else {
                                    setPage(1)
                                }
                            }}>1</a>
                    </li>
                    {<li className='border-0 rounded text-dark' style={{background: '#fff', paddingTop: '.75rem'}}>
                        ...
                    </li>}
                    </>}

                {pager ?.pages.map((page, index) =>
                    <li key={index}
                        className={pager ?.currentPage === page ?
                            ' page-link border-0 rounded  text-light  ' :
                            'page-link border-0  rounded text-dark  '}
                    >
                        <a className={pager ?.currentPage === page ?
                            ' page-link border-0 rounded  text-light  ' :
                            'page-link border-0  rounded text-dark  '}
                            style={{ userSelect: "none", background: pager ?.currentPage === page ? "#25375c" : "#ffffff", fontSize: "12px", }}
                            onClick={() => {
                                if (page == pager ?.currentPage) {
                                    return
                                } else {
                                    setPage(page)
                                }
                            }}>{page}</a>
                    </li>
                )}
    
                {pager?.totalPages > 10 && !pager?.pages?.includes(pager?.totalPages)  &&
                    <>
                    {pager?.endPage+1 < pager?.totalPages && <li className='border-0 rounded text-dark' style={{background: '#fff', paddingTop: '.75rem'}}>
                        ...
                    </li>}
                    <li className={pager ?.currentPage === pager?.totalPages ?
                            ' page-link border-0 rounded  text-light  ' :
                            'page-link border-0  rounded text-dark  '}
                    >
                        
                        <a className={pager ?.currentPage === pager?.totalPages ?
                            ' page-link border-0 rounded  text-light  ' :
                            'page-link border-0  rounded text-dark  '}
                            style={{ userSelect: "none", background: pager ?.currentPage === pager?.totalPages ? "#25375c" : "#ffffff", fontSize: "12px", }}
                            onClick={() => {
                                if (pager?.totalPages == pager ?.currentPage) {
                                    return
                                } else {
                                    setPage(pager?.totalPages)
                                }
                            }}>{pager?.totalPages}</a>
                    </li>
                    </>}
                <li style={{ marginLeft: "5px" }} className='page-item  rounded'  >
                    <a className='page-link border-0   rounded text-dark '
                        style={{ fontSize: "24px", opacity: pager ?.currentPage === pager ?.totalPages ? .3 : 1 }}
                        onClick={() => {
                            if (pager ?.currentPage === pager ?.totalPages) {
                                return
                            } else {
                                setPage(pager ?.currentPage + 1)
                            }
                        }}>&gt;</a>
                </li>
            </ul>
    </>);
    
}



Paginator.defaultProps = {
    initialPage: 1,
    pageSize: 10,
    items: []
};
export default Paginator;